// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetTypeService = {};
// console.log("🚀 ~ AssetTypeService:", AssetTypeService);

AssetTypeService.postAssetType = function (data) {
  return lossClient({
    url: "/assetType/add",
    method: "post",
    data: data,
  });
};

AssetTypeService.getAssetTypeList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 
  return lossClient({
    url:
      "/AssetType/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetTypeService.getAssetTypeApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  
  return lossClient({
    url:
      "/AssetType/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetTypeService.putAssetTypeApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { userId: data.userId, Note: data.note }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { userId: data.userId, Note: data.note }
      : data.approvalFlag == "approve"
      ? { userId: data.userId, Note: data.note }
      : { userId: data.userId, Note: data.note };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

 

  return lossClient({
    url: `/assetType/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

AssetTypeService.putAssetTypeRequest = function (data) {
 
  // var bodyRequest = {
  //   // AssetTypes: [{ AssetId: data.AssetId }],
  //   Request: data.request,
  //   note: data.note,
  //   userId: data.userId,
  // };
  var bodyRequest = {
    Request: data.request,
    note: data.note,
    userId: data.userId,
  };
 
  return lossClient({
    url: `/assetType/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: bodyRequest,
  });
};

AssetTypeService.getAssetTypeDetail = function (data) {
  return lossClient({
    url: `/assetType/${data.id}`,
    method: "get",
  });
};

AssetTypeService.updateAssetType = function (data) { 
  const { id, ...requestBody } = data; 
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/assetType/Edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

AssetTypeService.deleteAssetType = function (data) { 
  const { id, ...requestBody } = data; 
  return lossClient({
    url: "/assetType/Delete",
    method: "delete",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

export default AssetTypeService;
